import React from 'react'
import { Create, Datagrid, Edit, EditButton, List, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput } from 'react-admin'


const filters = [
  <TextInput source="uid" label="Uid" alwaysOn />,
  <TextInput source="name" label="Name" />,
]

const FundList = props => (
  <List {...props} filters={filters}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="uid" />
      <TextField source="website" />
      <TextField source="is_individual" />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
)

const FundEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="name" />
      <TextInput source="uid" />
      <TextInput source="website" />
      <TextInput source="is_individual" />
    </SimpleForm>
  </Edit>
)

const FundCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="uid" />
      <TextInput source="website" />
      <TextInput source="is_individual" />
    </SimpleForm>
  </Create>
)

const FundShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="uid" />
      <TextField source="website" />
      <TextField source="is_individual" />
    </SimpleShowLayout>
  </Show>
)

export { FundList, FundEdit, FundCreate, FundShow }
